import { calculateTargetMonthFromDate } from "src/choosePlan/components/plans/Plans";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import saveToBraze from "src/utils/brazeUploader";
import { calculateBMI } from "src/utils/calculateGoals";
import { NON_MED_PLAN } from "src/utils/health/planRecommendation";
import { getPersonalizedTargetDate } from "src/utils/pace";
import { getIndexFromGraphId } from "src/utils/pace/graphIndex";
import { savePlanToBraze } from "src/utils/plans";
import getStore from "src/utils/redux/store";
import { isHealthRoute } from "@utils/userSegment";
import {
  hasWeightLossGoal,
  isEligibleForStandaloneHRTBuyflow,
} from "@utils/userSegment/features";

export const saveRecommendedPlanToCRM = async () => {
  const state = getStore().getState();
  const surveyAnswers = getSurveyAnswers(state);
  const { currentBMI, targetBMI } = calculateBMI(surveyAnswers);
  const { recommendedPlan, recommendationContext } = state;

  // Clear purchase recommendations for FREEMIUM health route users
  // They don't have a recommended plan, so we clear any stale data from previous flows
  if (
    isHealthRoute() &&
    recommendationContext.recommendedHealthPlan === NON_MED_PLAN.FREEMIUM
  ) {
    await saveToBraze({
      user: {
        recommended_plan_url: null,
        recommended_plan_url_7day: null,
        recommended_plan_url_med: null,
        recommended_plan_price: null,
        recommended_plan_monthly_price: null,
        recommended_plan_regular_price: null,
        recommended_plan_regular_monthly_price: null,
        recommended_plan_duration: null,
        recommended_plan_starter_fee: null,
        recommended_month_goal: null,
      },
    });
    return;
  }

  // Skip sending targetBMI and targetMonthNameFull for health route users without weight loss goal
  const shouldSkipWeightLossData = isHealthRoute() && !hasWeightLossGoal();

  let targetMonthNameFull: string | undefined;
  if (!shouldSkipWeightLossData) {
    const graphId = isEligibleForStandaloneHRTBuyflow()
      ? "hrtOptIn"
      : "medOptIn";
    const targetDate = getPersonalizedTargetDate(getIndexFromGraphId(graphId));
    targetMonthNameFull =
      calculateTargetMonthFromDate(targetDate).targetMonthNameFull;
  }

  await savePlanToBraze({
    currentBMI,
    targetBMI: shouldSkipWeightLossData ? undefined : targetBMI,
    targetMonthNameFull,
    recommendedPlan,
  });
};
